import { unwrapApiResponse } from "../utils/apiUtils";
import { api } from "./apiSlice";

export interface AuditLog {
  id: number;
  tenantId: number | null;
  entityType: string;
  entityId: number;
  relatedEntityType: string | null;
  relatedEntityId: number | null;
  action: string;
  description: string | null;
  actorUserId: number | null;
  actorName: string | null;
  actorEmail: string | null;
  actorType: string;
  source: string;
  correlationId: string | null;
  details: string | null;
  metadata: string | null;
  createdAt: string;
  links: AuditLogLink[];
}

export interface AuditLogLink {
  id: number;
  entityType: string;
  entityId: number;
  role: string;
}

export type AuditSnapshot = Record<string, unknown>;

export interface AuditMetadataPayload {
  snapshot?: AuditSnapshot | null;
  data?: Record<string, unknown> | null;
}

export const getAuditDisplayText = (auditLog: Pick<AuditLog, "description" | "details">) =>
  auditLog.description ?? auditLog.details ?? "-";

export interface AuditLogFilter {
  entityType?: string;
  entityId?: number;
  includeRelated?: boolean;
  actorUserId?: number;
  action?: string;
  from?: string;
  to?: string;
  beforeCreatedAt?: string;
  beforeId?: number;
  page?: number;
  pageSize?: number;
}

export interface PagedResponse<T> {
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalRecords: number;
  data: T[];
  hasPrevious: boolean;
  hasNext: boolean;
}

export const auditApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAuditLogs: builder.query<PagedResponse<AuditLog>, AuditLogFilter | void>({
      query: (filters) => ({
        url: "audit",
        params: filters ?? {},
      }),
      transformResponse: unwrapApiResponse,
      providesTags: ["AuditLogs"],
    }),
  }),
});

export const { useGetAuditLogsQuery } = auditApi;
